// The code in this file is based on the Genesys Altocloud tracking snippet: https://all.docs.genesys.com/ATC/Current/AdminGuide/Tracking_snippet
const setup = () => {
  window._genesysJourneySdk = 'ac';
  const queuePush = (...args) => {
    (window.ac.q = window.ac.q || []).push(args);
  };
  window.ac = window.ac || queuePush;
  window.ac.l = Date.now();
  const script = document.createElement('script');
  const [firstScript] = document.getElementsByTagName('script');
  script.async = true;
  script.src = process.env.ALTOCLOUD_URL;
  script.charset = 'utf-8';
  firstScript.parentNode.insertBefore(script, firstScript);
};

const track = () => {
  setup();
  window.ac('init', process.env.ALTOCLOUD_ORG_ID, { region: process.env.ALTOCLOUD_REGION });
  window.ac('pageview');
};

export default track;
